import {
  Container,
  Heading,
  Content,
  FontAwesomeProIcon,
} from '@wienenergiegithub/ui-next';
import styles from './HeatPotential.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const HeatPotential = ({ heatPotential }) => (
  <Container>
    <Heading as="h3" className={styles.title} size="h2">
      Ihr Heizungspotential
    </Heading>
    <Content className={styles.subHeading}>
      Hier sehen Sie ihre Antworten und Tipps, wie Sie noch mehr Energie sparen
      können.
    </Content>
    {heatPotential?.map(({ question, answer, tipps, id }) => (
      <Container className={styles.tippContainer} key={`question-${id}`}>
        <div className={styles.answers}>
          <Heading className={styles.title} size="h5">
            {answer}
          </Heading>
          <Content noSpacing>{question}</Content>
        </div>
        <div className={styles.tippBox}>
          {tipps?.map(({ text, icon, title, id, links }) => (
            <div className={styles.iconText} key={`tipp-${id}-${id}`}>
              <FontAwesomeProIcon
                className={classNames(styles.icon, styles[icon])}
                icon={icon}
                role="presentation"
                type="solid"
              />
              <div>
                <Heading className={styles.title} size="h5">
                  {title}
                </Heading>
                <Content noSpacing>
                  <span className={styles.tipp}> {text}</span>
                  {links?.map(({ link, linkText }) => (
                    <a
                      className={classNames(styles.tipp, 'tertiary')}
                      href={link}
                      key={link}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {linkText}
                    </a>
                  ))}
                </Content>
              </div>
            </div>
          ))}
        </div>
      </Container>
    ))}
  </Container>
);

HeatPotential.propTypes = {
  heatPotential: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      id: PropTypes.number,
      question: PropTypes.string,
      tipps: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.string,
          id: PropTypes.number,
          link: PropTypes.string,
          text: PropTypes.string,
          title: PropTypes.string,
        }),
      ),
    }),
  ),
};

export { HeatPotential };
